<template>
  <base-slide-panel :isOpen="panelOpen" :large="true" @closePanel="togglePanel">
    <template slot="header">
      <div class="h-16 bg-secondary dark:bg-darkblue-600 flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <base-icon name="lens"/>
          <h2 class="font-bold ml-2">{{ $t('app.saved_searches') }}</h2>
        </div>
        <span class="cursor-pointer" @click="togglePanel">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-4 dark:bg-darkblue-800 dark:text-darkblue-200">
        <el-form
          ref="ruleForm"
        >
          <div class="lg:mb-2">
            <div v-if="emptySearches" class="p-2">
              <label class="text-sm font-semibold text-secondary-600 block mb-1 pl-1">{{ $t('app.empty_searches') }}</label>
              <br/>
            </div>
            <div v-else>
              <base-search-item
                v-for="search in searches"
                :key="search.id"
                :id="search.id"
                :nombre="search.name"
                :tags="search.tags"
                @applySearch="applySearch"
                @deleteSearch="deleteSearch"
              />
            </div>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button @click="togglePanel" class="w-full" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
    </template>
  </base-slide-panel>
</template>

<script>
import { i18n } from '@/i18n'
import { getBusquedas } from '@/services/searches/getBusquedas'
import { deleteBusqueda } from '@/services/searches/deleteBusqueda'

export default {
  /* eslint-disable camelcase */
  name: 'filter-panel',
  props: {
    panelOpen: {
      type: Boolean,
      default: false
    },
    vuexnamespace: {
      type: String,
      default: ''
    },
    idVista: {
      type: Number,
      default: -1
    }
  },
  data: function () {
    return {
      // vuexnamespace: 'users',
      isOpen: this.panelOpen,
      searches: [],
      numericExceptions: [
        '01',
        '02',
        '03',
        '04',
        '05',
        '06',
        '07',
        '08',
        '09',
      ],
      // types: [],
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ],
    }
  },
  watch: {
    panelOpen: {
      handler: 'panelOpenHandler'
    }
  },
  mounted: async function () {
    this.updateData()
  },
  computed: {
    emptySearches: function () {
      return this.searches === undefined || this.searches === null |this.searches.length === 0
    },
    labelFiltros: function () {
      return this.$store.getters['config/LABEL_FILTROS']
    },
  },
  methods: {
    updateData: async function () {
    // Get búsquedas by vista
      try {
        this.$store.commit('setIsLoading', true)
        this.searches = []
        const params = {
          idVista: this.idVista
        }
        const response = await getBusquedas(params)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          setTimeout(() => {
            response.respuesta.forEach(element => {
              const search = {
                id: element.IdBusqueda,
                name: element.Nombre,
                tags: []
              }
              element.Filtros.forEach(filtro => {
                const tag = []
                tag.push(filtro.Clave)
                const labelFiltro = this.labelFiltros.find(x => x.idVista.includes(this.idVista) && x.id === filtro.Clave)
                tag.push(labelFiltro?.label ?? i18n.t('app.unknown'))
                const valor = filtro.Valor === 'true' ? true 
                  : filtro.Valor === 'false' ? false 
                    : (!isNaN(filtro.Valor) && !this.numericExceptions.includes(filtro.Valor)) ? parseInt(filtro.Valor) 
                      : filtro.Valor
                tag.push(valor)
                const extraparams = this.discard(['id', 'idVista', 'label'], labelFiltro)
                if (Object.keys(extraparams).length) {
                  tag.extraparams = extraparams
                }
                if (filtro.Clave === 'partner') {
                  const dynamicValue = this.$store.getters['app/tiposPartners'].filter(x => x.IdPartner === valor)[0].Nombre
                  tag.push(dynamicValue) 
                }  
                if (filtro.Clave === 'tipoServicio') {
                  const dynamicValue = this.$store.getters['app/tiposServicio'].filter(x => x.id === valor)[0].name
                  tag.push(dynamicValue) 
                }   
                if (filtro.Clave === 'grupoCliente') {
                  const dynamicValue = this.$store.getters['app/tiposGruposClientes'].filter(x => x.idCliente === valor)[0].Nombre
                  tag.push(dynamicValue) 
                }   
                if (filtro.Clave === 'PGE') {
                  const aux = this.$store.getters['app/tiposPGE'].filter(x => x.id === valor)[0]
                  const dynamicValue = aux.Nombre || aux.name
                  tag.push(dynamicValue) 
                }
                // Filtros multiples
                const actualTag = search.tags.filter(x => x[0] === tag[0])
                if (actualTag.length > 0) {
                  if (!Array.isArray(actualTag[0][2])) {
                    const valueBeforeArray = actualTag[0][2]
                    actualTag[0][2] = []
                    actualTag[0][2].push(valueBeforeArray)
                  }
                  actualTag[0][2].push(tag[2])
                } else {
                  // Filtros normales
                  search.tags.push(tag)
                }
              })
              this.searches.push(search)
              this.$emit('updateNumberSearches', this.searches.length)
            })
          }, 200)
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    panelOpenHandler: function (data) {
    },
    togglePanel: function () {
      this.isOpen = !this.isOpen
      this.$emit('togglePanel')
    },
    applySearch: function (tags) {
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', tags)
      this.$emit('applyFilters', true)
      this.isOpen = !this.isOpen
      this.$emit('togglePanel')
    },
    deleteSearch: async function (id) {
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idBusqueda: id
        }
        const response = await deleteBusqueda(params)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.searches = this.searches.filter(x => x.id !== id)
          this.doFeedback(i18n.t('feedback.success.search_deleted_msg'), 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
        this.$emit('updateNumberSearches', this.searches.length)
      }
    },
  }
}
</script>

<style lang="scss" scoped></style>
